import * as React from 'react';
import { Input } from 'antd';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { IWidget } from 'common/schema/widget/Widget';
import { getWidgetInputViewType } from '../helper/getWidgetInputViewType';
import { WidgetInputViewType } from 'common/schema/widget/input/WidgetInputViewType';
import TextArea from 'antd/lib/input/TextArea';
import { getWidgetInputText } from '../helper/getWidgetInputText';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { TextAreaInput } from 'client/ui/form/input/TextAreaInput';
import { TextInput } from 'client/ui/form/input/TextInput';
import { useFormWidgetProps } from './contextual/useFormWidgetProps';

export interface FormWidgetInputTextViewProps {
  widget: IWidget;
}

export function FormWidgetInputTextView(props: FormWidgetInputTextViewProps) {
  const { widget } = props;

  // Abbiamo un singolo metadato per i campi di testo
  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;

  const [inputProps] = useFormWidgetProps(widget);

  return (
    <FormWidgetItem name={name} widget={props.widget}>
      {getWidgetInputViewType(props.widget) === WidgetInputViewType.TextArea ? (
        <TextAreaInput
          name={name}
          placeholder={widget.input!.placeholder}
          {...inputProps}
        />
      ) : (
        <TextInput
          name={name}
          placeholder={widget.input!.placeholder}
          {...inputProps}
        />
      )}
    </FormWidgetItem>
  );
}
